import React, { Component } from 'react'
import { Dropdown, Tab, Tabs } from "react-bootstrap";
import NeedHelp from '../Elements/NeedHelp';
import { getInitialRoute } from '../../../../../../utils';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import CheckBoxField from '../Elements/CheckboxField';
import InputField from '../Elements/InputField';
import { createFeedAction } from '../../../../../../actions/addFeedActions';


class Tumblr extends Component {
    state = {
        text: "",
        handle:"",
        handleError:false,
        manuallyApprove: false,
        error: false,
        filter: 'Hashtag',
        loading: false,
    }

    componentDidMount() {
        this.props.onFilterNameChange(this.state.filter)
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, error:false,handleError:false });
    onManuallyApproveChange = (value) => this.setState({ manuallyApprove: value })

    onSubmit = () => {
        const {text,handle, manuallyApprove, filter } = this.state;
        const { hideAddfeed, navigation, wallId } = this.props;
        const filterId = this.getFilterType();

        if ((!text || text == "") && filter == 'Hashtag'){
            this.setState({ error: true })
        }else if((!text || text == "") && filter == 'Hashtag'){
            this.setState({ handleError: true })
        } else {
            this.setState({ error: false, handleError:false, loading:true })

            const obj = {
                wallId: wallId,
                networkId: 11,
                filter: filterId,
                moderation: manuallyApprove ? 1 : 0,
            }

            if (filterId == 1) {
                obj['feedText'] = handle;
            } else if (filterId == 2) {
                obj['feedText'] = text;
            }

            createFeedAction(obj,11,(feedId)=>this.setState({loading:false},()=>{
                if(feedId){
                    hideAddfeed();
                    navigation(`/moderation/index/${wallId}`);
                }
            }));
        }
    }

    needSupportLinks = (filter) => {
        if (getInitialRoute() === 'widget') {
            switch (filter) {
                case 'Hashtag':
                    return ['https://vimeo.com/715497002', 'https://taggbox.com/support/how-to-add-tumblr-feeds/']
                case 'Handle':
                    return ['https://vimeo.com/715496819', 'https://taggbox.com/support/how-to-add-tumblr-feeds/']
                default:
                    return ['https://vimeo.com/715497002', 'https://taggbox.com/support/how-to-add-tumblr-feeds/']
            }
        } else {
            switch (filter) {
                case 'Hashtag':
                    return ['https://vimeo.com/537166800', '']
                case 'Handle':
                    return ['https://vimeo.com/715496819', '']
                default:
                    return ['https://vimeo.com/537166800', '']
            }
        }
    }

    getFilterType = () => {
        return this.props.feedInfo[0].networkTab.reduce((acc, curr) => {
            if ((curr.feedName).toLowerCase() == (this.state.filter).toLowerCase()) {
                return curr.filter;
            }
            return acc;
        }, this.props.feedInfo[0].networkTab[0].filter)
    }


    render() {
        const { text, manuallyApprove, error, loading,handle,handleError, filter } = this.state;

        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="form-body create_feed_wt">
                        <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details personalizePopup">
                            <Tabs defaultActiveKey={'Hashtag'} id="TumblrTab" onSelect={(e) => this.setState({ filter: (e) },()=>this.props.onFilterNameChange(e))} className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3">
                                <Tab eventKey={'Hashtag'} key={'Hashtag'} className="nav-link className= p-0" title={<span>{'Hashtag'}</span>}>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className={`fas fa-hashtag`}></i>
                                                </span>
                                            </div>
                                            <InputField autocomplete={true} name={"text"} className={`autosearch mycheck form-control`} placeholder="Enter hashtag" value={text} onChangeHandler={(e) => this.onTextChange(e)} />
                                        </div>
                                        {error ? <span id="feedsfield2error" className="errorMessage required">This field is required</span> : null}
                                    </div>
                                    <div className="hideforBSearch">
                                        <div className="checkbox-inline">
                                            <CheckBoxField isChecked={manuallyApprove} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id={`checkbox_hashtag`} />
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey={'Handle'} key={'Handle'} className="nav-link className= p-0" title={<span>{'Handle'}</span>}>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className={`fas fa-at`}></i>
                                                </span>
                                            </div>
                                            <InputField autocomplete={true} name={"handle"} className={`autosearch mycheck form-control`} placeholder="Enter user handle" value={handle} onChangeHandler={(e) => this.onTextChange(e)} />
                                        </div>
                                        {handleError ? <span id="feedsfield2error" className="errorMessage required">This field is required</span> : null}
                                    </div>
                                    <div className="hideforBSearch">
                                        <div className="checkbox-inline">
                                            <CheckBoxField isChecked={manuallyApprove} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id={`checkbox_handle`} />
                                        </div>
                                    </div>
                                </Tab>
                            </Tabs>

                            <div className="form-actions w-100">
                                <div className="f-between flex-wrap border-top pt-3 mt-4">
                                    <NeedHelp text={'Need help in adding feeds?'} videoUrl={this.needSupportLinks(filter)[0]} supportLink={this.needSupportLinks(filter)[1]} />
                                    <SubmitFeedRequest onBack={this.props.onBack} onSubmit={this.onSubmit} loading={loading} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Tumblr